<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>

                        <template #cell(codiceFlussoImpegnativa)="{ item }">
                            {{ item.impegnativaTipo || item.codiceFlusso }}
                        </template>

                        <template #cell(idPrestazione)="{ item }">
                            
                           {{ item.codicePrestazione}} - {{ item.prestazioneNome || item.id }}
                        </template>

                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Associazione" @click="onClickModificaAssociazione(item)">
                                    <font-awesome-icon icon="edit" />
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Elimina Associazione" variant="outline-danger" @click="onClickEliminaAssociazione(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
                <rsa-configurazione-impegnativa-gruppo-prestazione-modal-edit-component ref="cmpImpegnativaGruppoPrestazioneModalEdit" @onSave="loadData" @closeModal="loadData" @deleteGruppoAssociazione="loadData" />
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import RsaConfigurazioneImpegnativaGruppoPrestazioneModalEditComponent from "./RsaConfigurazioneImpegnativaGruppoPrestazioneModalEditComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    props: {},
    mixins: [UtilityMixin],
    components: { RsaConfigurazioneImpegnativaGruppoPrestazioneModalEditComponent },
    data() {
        return {
            pathResource: "/rsaimpegnativagruppoprestazione",
            perPage: 50,
            currentPage: 1,
            rows: 0,
            btnNuovoGruppoHidden: false,
            showModalLoading: false,
            listKey: 0,
            filtroImpegnativaGruppoPrestazioni: {},
            items: [],
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Impegnativa",
                    key: "codiceFlussoImpegnativa",
                    sortable: true,
                },
                {
                    label: "Prestazioni",
                    key: "idPrestazione",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroImpegnativaGruppoPrestazioni"]) {
                me.filtroImpegnativaGruppoPrestazioni = JSON.parse(sessionStorage["filtroImpegnativaGruppoPrestazioni"]);
            }
            me.filtroImpegnativaGruppoPrestazioni.page = me.currentPage;
            me.filtroImpegnativaGruppoPrestazioni.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroImpegnativaGruppoPrestazioni, me.loadDataSuccess, me.loadDataError);
            me.$refs.cmpImpegnativaGruppoPrestazioneModalEdit.loadTipoPrestazioneData();
            me.$refs.cmpImpegnativaGruppoPrestazioneModalEdit.loadTipoImpegnativaData();
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore nel caricamento dei dati:", error);
            me.$bvToast.toast("Errore nel caricamento dei dati", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.$emit("afterLoadData");
        },

        onClickModificaAssociazione(item) {
            let me = this;
            me.$refs.cmpImpegnativaGruppoPrestazioneModalEdit.show(item);
        },
        nuovaAssociazione() {
            let me = this;
            me.$refs.cmpImpegnativaGruppoPrestazioneModalEdit.show({
                id: null,
                codiceFlussoImpegnativa: null,
                idPrestazione: null,
            });
        },

        onClickEliminaAssociazione(item) {
            let me = this;
            me.$refs.cmpImpegnativaGruppoPrestazioneModalEdit.onDeleteGruppoAssocizione(item);
        },

        /* onSaveGruppo() {
            let me = this;
            me.loadData();
        },
        onCloseGruppo() {
            let me = this;
            me.loadData();
        },
        onDeleteGruppo() {
            let me = this;
            me.loadData();
        }, */
    },
};
</script>
